module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_step02-d059e5f2dc30d7a4719db5c4bad0cc9f.png";